import {BaseApi} from '@/api/base-api';
import {GetAllPagesResponse} from '@/components/dashboard/pages/landing-page-optimizer/types';
import {AxiosResponse} from 'axios';

export class KeywordsApi extends BaseApi {
  public async getOverviewPage() {
    try {
      const {data}: AxiosResponse<GetAllPagesResponse> = await this.axios({
        method: 'GET',
        url: 'target-keywords/',
      });

      return data;
    } catch (e) {
      return Promise.reject(e);
    }
  }

  public async findTargetKeyword(payLoad) {
    try {
      const {data}: AxiosResponse<GetAllPagesResponse> = await this.axios({
        method: 'POST',
        url: 'target-keywords/',

        data: payLoad,
      });

      return data;
    } catch (e) {
      return Promise.reject(e);
    }
  }

  public async getTargetKeywordDetail(id) {
    try {
      const {data}: AxiosResponse<GetAllPagesResponse> = await this.axios({
        method: 'GET',
        url: `target-keywords/${id}/`,
      });

      return data;
    } catch (e) {
      return Promise.reject(e);
    }
  }

  public async saveTargetKeyword(id) {
    try {
      const {data}: AxiosResponse<GetAllPagesResponse> = await this.axios({
        method: 'POST',
        url: `target-keywords/${id}/save/`,

      });

      return data;
    } catch (e) {
      return Promise.reject(e);
    }
  }

  public async removeTargetKeyword(id) {
    try {
      const {data}: AxiosResponse<GetAllPagesResponse> = await this.axios({
        method: 'POST',
        url: `target-keywords/${id}/remove/`,

      });

      return data;
    } catch (e) {
      return Promise.reject(e);
    }
  }

  public async getNewArticleDetail(id) {
    try {
      const {data}: AxiosResponse<GetAllPagesResponse> = await this.axios({
        method: 'GET',
        url: `target-keywords/${id}/create-article/`,

      });

      return data;
    } catch (e) {
      return Promise.reject(e);
    }
  }
}
